
export function binaryArrayToHex(binaryArray) {
    const binToHexMap = {
        '0000': '0', '1000': '1', '0100': '2', '1100': '3',
        '0010': '4', '1010': '5', '0110': '6', '1110': '7',
        '0001': '8', '1001': '9', '0101': 'a', '1101': 'b',
        '0011': 'c', '1011': 'd', '0111': 'e', '1111': 'f'
    };
    let hexString = '';

    for (let i = 0; i < binaryArray.length; i += 4) {
        const group = binaryArray.slice(i, i + 4).join('');
        hexString = binToHexMap[group] + hexString;
    }

    hexString = hexString.replace(/^0+(.)/, '$1');

    return hexString;
}

export function hexToBinaryArray(hexString) {
    const hexToBinMap = {
        '0': [0, 0, 0, 0], '1': [1, 0, 0, 0], '2': [0, 1, 0, 0], '3': [1, 1, 0, 0],
        '4': [0, 0, 1, 0], '5': [1, 0, 1, 0], '6': [0, 1, 1, 0], '7': [1, 1, 1, 0],
        '8': [0, 0, 0, 1], '9': [1, 0, 0, 1], 'a': [0, 1, 0, 1], 'b': [1, 1, 0, 1],
        'c': [0, 0, 1, 1], 'd': [1, 0, 1, 1], 'e': [0, 1, 1, 1], 'f': [1, 1, 1, 1]
    };
    let binaryArray = [];

    for (let i = hexString.length - 1; i >= 0; i--) {
        const char = hexString[i];
        binaryArray.push(...hexToBinMap[char]);
    }

    return binaryArray;
}

export function indexIsSet(binaryArray, index) {
    if (index < 0 || index >= binaryArray.length) return false;
    return binaryArray[index] === 1;
}

export function setArrayIndex(binaryArray, index, value=1) {
    if (index < 0 || (index >= binaryArray.length && value === 0)) return;
    while (binaryArray.length <= index || binaryArray.length % 4 !== 0) {
        binaryArray.push(0);
    }
    binaryArray[index] = value;
}
